import { FetchState, InvestmentManagementType } from "@/shared/types";
import { formatCurrency } from "@/shared/currency";

export function hasQuarterlyFee (managedType: InvestmentManagementType): boolean {
    if (this.enrollmentStore.feeScheduleFetchState !== FetchState.Loaded) {
        return false;
    }
    const accountFees = this.enrollmentStore.investmentFeeForAccountType(managedType);

    return accountFees.annualBasis !== 0;
}

export function quarterlyFee (managedType: InvestmentManagementType): string {
    if (this.enrollmentStore.feeScheduleFetchState !== FetchState.Loaded) {
        return "";
    }
    const accountFees = this.enrollmentStore.investmentFeeForAccountType(managedType);

    if (accountFees.annualBasis === 0) {
        return "No Fee";
    }

    let result = (accountFees.annualBasis / 400).toFixed(2) + "% of AUA";

    if (accountFees.quarterlyMaximum === 0 && accountFees.quarterlyMinimum === 0) {
        return result;
    }
    result = result + " (";
    if (accountFees.quarterlyMinimum !== 0) {
        result = result + "Min " + formatCurrency(accountFees.quarterlyMinimum);
    }
    if (accountFees.quarterlyMinimum !== 0 && accountFees.quarterlyMaximum !== 0) {
        result = result + "; ";
    }
    if (accountFees.quarterlyMaximum !== 0) {
        result = result + "Max " + formatCurrency(accountFees.quarterlyMaximum);
    }
    return result + ")";
}